export const ACCOUNT_PREFERENCE = 'account.preferences';
export const ACCOUNT_COMMON_TEST = 'account.common_test';

const SocialLabels = {
  account: {
    preferences: {
      lbl_prefrence_connected: 'Connected',
      lbl_prefrence_connectTo: 'Connect to ',
      lbl_prefrence_social_points_heading: 'Congratulations!',
      lbl_prefrence_social_points_text_1: 'You’ve earned',
      lbl_prefrence_social_points_text_2:
        'My Place Rewards Points for linking your facebook account!',
      lbl_prefrence_social_points_text_2_instagram:
        'My Place Rewards Points for linking your instagram account!',
      lbl_prefrence_social_points_text_2_twitter:
        'My Place Rewards Points for linking your twitter account!',
      lbl_prefrence_social_points_text_3:
        'Points will appear in your account in approximately 24-48 hours.',
      lbl_prefrence_social_points_text_4: 'Want even more points?',
      lbl_prefrence_social_points_text_5: ' Check out other ways to earn!',
      lbl_prefrence_social_points_modal_viewall_btn: 'VIEW ALL',
      lbl_prefrence_social_points_modal_close_btn: 'CLOSE',
      lbl_prefrence_social_text: 'Link your social accounts to earn extra points!',
    },
    common_test: {},
  },
  global: {},
};

export default SocialLabels;
